import { render, staticRenderFns } from "./EventCalendarList.vue?vue&type=template&id=64f62feb&"
import script from "./EventCalendarList.vue?vue&type=script&lang=js&"
export * from "./EventCalendarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports